import { render, staticRenderFns } from "./TipoAquisicaoIBPForm.vue?vue&type=template&id=e5d03654"
import script from "./TipoAquisicaoIBPForm.vue?vue&type=script&lang=js"
export * from "./TipoAquisicaoIBPForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports